import React, { FunctionComponent } from "react"
import LoadingSpinnerStyles from "../../common/LoadingSpinner.module.scss"
import {
    CircularProgress,
    Drawer,
    Grid,
    Step,
    StepContent,
    StepLabel,
    Stepper,
    Typography
} from "@material-ui/core"
import { BatchPageProvider, useBatchPageContext } from "./useBatchPageContext"
import { UploadFileStepDescription } from "./Upload"
import { ReviewAudio } from "./reviewAudio/ReviewAudio"
import { BatchTranslate } from "./BatchTranslate"
import { BatchPageContent } from "./BatchPageContent"
import { Approve } from "./approveAudio/Approve"
import styles from "./BatchPage.module.scss"
import {
    StepControlsProvider,
    useStepControlsContext
} from "../../features/StepControls/useStepControlsContext"
import { Title } from "../../components/Title"

interface Step {
    component: JSX.Element
    name: string
}

export const BatchPage: FunctionComponent = () => {
    return (
        <StepControlsProvider>
            <BatchPageProvider>
                <BaseBatchPage />
            </BatchPageProvider>
        </StepControlsProvider>
    )
}

export const BaseBatchPage: FunctionComponent = () => {
    const { state: stepControls } = useStepControlsContext()
    const { pageLoading } = useBatchPageContext()
    const steps: Step[] = [
        {
            component: <UploadFileStepDescription />,
            name: "Upload"
        },
        {
            component: <BatchTranslate />,
            name: "Translate"
        },
        {
            component: <ReviewAudio />,
            name: "Review Audio"
        },
        {
            component: <Approve />,
            name: "Approve"
        }
    ]

    if (pageLoading) {
        return (
            <div className={LoadingSpinnerStyles.LoadingSpinner__absolute__center}>
                <CircularProgress
                    data-testid="batchPageLoadingSpinner"
                    id="batchPageLoadingSpinner"
                />
            </div>
        )
    }

    return (
        <>
            <Title text={"Batch"} />
            <Grid container direction={"row"} spacing={1} className={styles.BatchPage}>
                <Grid container item xs={3}>
                    <Stepper
                        className={styles.BatchPage__stepper}
                        activeStep={stepControls.activeStep}
                        orientation="vertical"
                    >
                        {steps.map(functionComponent => (
                            <Step key={functionComponent.name}>
                                <StepLabel>
                                    <Typography>{functionComponent.name}</Typography>
                                </StepLabel>
                                <StepContent>{functionComponent.component}</StepContent>
                            </Step>
                        ))}
                    </Stepper>
                </Grid>
                <Grid container item xs={9}>
                    <Grid item className={styles.BatchPage__content}>
                        <BatchPageContent />
                    </Grid>
                </Grid>
            </Grid>
        </>
    )
}
